import NavBar from '../components/NavBar'
import HeroSection from '../components/HiringPayrollHROperations/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/HiringPayrollHROperations/ProcessSection'
import TechStackMarquee from '../components/HiringPayrollHROperations/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const HiringPayrollHROperations = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default HiringPayrollHROperations